import { RealEstateCategory } from '../../../@types/types'
import { ValuationPropertyType } from '../../../@types/valuation-types'

// MVP: valuation supports APARTMENT explicitly; all other categories are mapped to OTHER for now.
export function toValuationPropertyType(category: RealEstateCategory): ValuationPropertyType {
  return category === RealEstateCategory.APARTMENT ? ValuationPropertyType.APARTMENT : ValuationPropertyType.OTHER
}
